import React, { forwardRef } from 'react';
import { Chart } from '../../../../../../CommonComponents/OPL/charts/Chart';
import { RefObjectForHighchartsReact } from '../../../../../../CommonComponents/OPL/charts/Chart.types';
import { ChartDataDTO } from '../../../../../api/useDecumulationGoalQuery';
import { useCharitableGivingChart } from './useCharitableGivingChart';

interface Props {
  data: ChartDataDTO;
}

export const CharitableGivingChart = forwardRef<RefObjectForHighchartsReact, Props>(
  (props, ref) => {
    const { chartConfig } = useCharitableGivingChart(props);

    return <Chart ref={ref} options={chartConfig} />;
  },
);
